/**
 * Restaurant configuration - Fallback/Supplement to API data
 *
 * IMPORTANT: This contains data NOT yet available in the menu config API:
 * - Address (street, city, state, zipCode)
 * - Operating hours
 * - Phone number
 * - Map coordinates/image
 *
 * The restaurant name and branding (colors) come from the API.
 * This config is used as a fallback for missing API fields.
 */

export interface RestaurantConfig {
  name: string
  email?: string
  address: {
    street: string
    city: string
    state: string
    zipCode: string
  }
  hours: {
    monday: string
    tuesday: string
    wednesday: string
    thursday: string
    friday: string
    saturday: string
    sunday: string
  }
  phone: string
  mapCoordinates: {
    lat: number
    lng: number
  }
  mapImageUrl?: string
  /** External delivery platform URLs (redirects users to partner apps) */
  uberEatsUrl?: string
  doordashUrl?: string
}

export const restaurantConfig: RestaurantConfig = {
  name: 'Restaurant',
  email: 'support@restaurant.com',
  address: {
    street: '1440 Rue Crescent',
    city: 'Montreal',
    state: 'QC',
    zipCode: 'H3G 2B5',
  },
  hours: {
    monday: '11:00 AM - 10:00 PM',
    tuesday: '11:00 AM - 10:00 PM',
    wednesday: '11:00 AM - 10:00 PM',
    thursday: '11:00 AM - 10:00 PM',
    friday: '11:00 AM - 11:00 PM',
    saturday: '10:00 AM - 11:00 PM',
    sunday: '10:00 AM - 9:00 PM',
  },
  phone: '(514) 555-0123',
  mapCoordinates: {
    lat: 45.4988,
    lng: -73.5789,
  },
  uberEatsUrl: 'https://www.ubereats.com/store/restaurant',
  doordashUrl: 'https://www.doordash.com/store/restaurant',
}

/**
 * Google Maps Configuration
 *
 * To enable the interactive map on the PreMenuPage:
 * 1. Get a Google Maps Embed API key: https://developers.google.com/maps/documentation/embed/get-api-key
 * 2. Replace "YOUR_GOOGLE_MAPS_API_KEY" in PreMenuPage.tsx with your actual key
 * 3. The map will automatically display your restaurant location
 *
 * Note: The map is optional - if no API key is provided, a fallback icon is shown
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'YOUR_GOOGLE_MAPS_API_KEY'
